<script setup lang="ts">
import { computed } from 'vue';
import { CircleDot } from 'lucide-vue-next';

type SeverityLevel = 'critical' | 'high' | 'medium' | 'low' | 'info';

interface Props {
  severity: SeverityLevel;
  label?: string;
}

const props = withDefaults(defineProps<Props>(), {
  label: '',
});

const severityClasses: Record<SeverityLevel, string> = {
  critical: 'bg-severity-critical/15 text-severity-critical border-severity-critical/30',
  high: 'bg-severity-high/15 text-severity-high border-severity-high/30',
  medium: 'bg-severity-medium/15 text-severity-medium border-severity-medium/30',
  low: 'bg-severity-low/15 text-severity-low border-severity-low/30',
  info: 'bg-severity-info/15 text-severity-info border-severity-info/30',
};

const badgeClass = computed(() => {
  return `severity-badge inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border cwr-motion ${severityClasses[props.severity]}`;
});

const labelText = computed(() => props.label || props.severity.toUpperCase());
</script>

<template>
  <span :class="badgeClass">
    <CircleDot class="w-3 h-3" />
    <span>{{ labelText }}</span>
  </span>
</template>
